import { z } from 'zod';

export const EvaluationExperimentGeneratedSummaryConfigHighlightSchema =
  z.object({
    configName: z.string(),
    recall: z.number().nullable(),
    fpReject: z.number().nullable(),
    precision: z.number().nullable(),
    verdict: z.string(),
    recommended: z.boolean(),
  });

export const EvaluationExperimentGeneratedSummaryCategoryInsightSchema =
  z.object({
    category: z.string(),
    note: z.string(),
  });

export const EvaluationExperimentGeneratedSummarySchema = z.object({
  headline: z.string(),
  overview: z.string(),
  configHighlights: z
    .array(EvaluationExperimentGeneratedSummaryConfigHighlightSchema)
    .max(6),
  categoryInsights: z
    .array(EvaluationExperimentGeneratedSummaryCategoryInsightSchema)
    .max(6),
  recommendedConfig: z.string(),
  routingNote: z.string(),
  playbookNotes: z.array(z.string()).max(5),
  keyLearnings: z.array(z.string()).max(5),
  caveats: z.array(z.string()).max(3),
});

export const EvaluationExperimentSummaryTableMetricSchema = z.object({
  configName: z.string().min(1).max(200),
  recall: z.number().min(0).max(1).nullable(),
  precision: z.number().min(0).max(1).nullable(),
  expectedPositive: z.number().int().nonnegative(),
  truePositives: z.number().int().nonnegative(),
  predictedPositive: z.number().int().nonnegative(),
});

export const GenerateEvaluationExperimentSummaryRequestSchema = z.object({
  positiveLabels: z.array(z.string().min(1).max(64)).min(1).max(16).optional(),
  tableMetrics: z
    .array(EvaluationExperimentSummaryTableMetricSchema)
    .max(20)
    .optional(),
});

export const GetEvaluationExperimentGeneratedSummaryResponseSchema = z.object({
  summary: EvaluationExperimentGeneratedSummarySchema.nullable(),
  generatedAt: z.iso.datetime().nullable(),
  model: z.string().nullable(),
});

export const GenerateEvaluationExperimentGeneratedSummaryResponseSchema =
  z.object({
    summary: EvaluationExperimentGeneratedSummarySchema,
    generatedAt: z.iso.datetime(),
    model: z.string(),
  });

export type GenerateEvaluationExperimentSummaryRequest = z.infer<
  typeof GenerateEvaluationExperimentSummaryRequestSchema
>;
export type EvaluationExperimentGeneratedSummary = z.infer<
  typeof EvaluationExperimentGeneratedSummarySchema
>;
export type EvaluationExperimentGeneratedSummaryConfigHighlight = z.infer<
  typeof EvaluationExperimentGeneratedSummaryConfigHighlightSchema
>;
export type EvaluationExperimentGeneratedSummaryCategoryInsight = z.infer<
  typeof EvaluationExperimentGeneratedSummaryCategoryInsightSchema
>;
export type GetEvaluationExperimentGeneratedSummaryResponse = z.infer<
  typeof GetEvaluationExperimentGeneratedSummaryResponseSchema
>;
export type GenerateEvaluationExperimentGeneratedSummaryResponse = z.infer<
  typeof GenerateEvaluationExperimentGeneratedSummaryResponseSchema
>;
